import React from 'react';
import styles from './dot-indicator.scss';

import Dot from './dot';

type Props = {
  /** What dot to set focus to (1-indexed) */
  index: number,
  /** Number of dots */
  max: number,
  /** Callback for when an element is selected */
  onSelect?: number => void,
  /** Callback for moving an element */
  onSort?: (number, number) => void,
  /** Style for holder */
  style?: {}
};

function getDots(index, max, onClick, onSort) {
  let i = 0, ret = [];
  while (i++ < max) {
    ret.push(
      <Dot
        className={(i === index) ? styles.emphasized : styles.dot}
        index={i - 1}
        key={i}
        onClick={onClick}
        onSort={onSort}
      />
    );
  }
  
  return ret;
}

const DotIndicator = ({ index, max, onClick, onSort, style }: Props) => {
  return (
    <div className={styles.root} style={style}>
      <div className={styles.dotHolder}>
        {getDots(index, max, onClick, onSort)}
      </div>
    </div>
  );
};

export default DotIndicator;
